export const UserWhiteIcon = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.25 12C18.4926 12 19.5 13.0074 19.5 14.25V15C19.5 17.9572 16.7107 21 12 21C7.28926 21 4.5 17.9572 4.5 15V14.25C4.5 13.0074 5.50736 12 6.75 12H17.25ZM12 2.25C14.2782 2.25 16.125 4.09683 16.125 6.375C16.125 8.65317 14.2782 10.5 12 10.5C9.72183 10.5 7.875 8.65317 7.875 6.375C7.875 4.09683 9.72183 2.25 12 2.25Z"
      fill="white"
    />
  </svg>)
}